import React, { useState, useRef, useEffect } from "react";
/** Services Import */
import Global from "../../services/Common/Global";
import Commons from "../../services/Common/Common";
/** Components Import */
import Calendar from "../../Components/Calendar";
import { Dropdown, Button, Loading, Dialog } from "../../Components/Bootstrap";
import { Card, Stack } from "react-bootstrap";

function Education() {
  const [loading, setLoading] = useState(false);
  const [dateValue, setDateValue] = useState(new Date());
  const [eduAllList, setEduAllList] = useState([]); // 가공하지 않은 모든 edu 리스트
  const [eduList, setEduList] = useState([]); // 등록된 교육이 있는 날
  const [myEduList, setMyEduList] = useState([]); // 내가 교육을 등록한 날
  const [eduComboList, setEduComboList] = useState([]); // 선택한 날에 있는 교육 리스트 저장
  const [eduValue, setEduValue] = useState(""); // 콤보에서 선택한 데이터 저장
  const [dialogToggle, setDialogToggle] = useState(false);
  const [dialogDateValue, setDialogDateValue] = useState(new Date());
  const [eduDetailList, setEduDitailList] = useState([]);
  const [dialogToggle1, setDialogToggle1] = useState(false);
  const deleteDatas = useRef({});

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    try {
      await SelectLogic(); // 교육이 등록된 날짜 조회
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  // 교육이 등록된 날짜 조회
  const SelectLogic = async (_ym = Commons.DateFormating(new Date(), 8)) => {
    setLoading(true);
    let _eduAllList = [];
    let _eduList = [];
    let _myEduList = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Education.Education,
        {
          ym: _ym,
        }
      ).then((result) => {
        let data = result.data;
        // console.log("교육이 등록된 날짜 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _eduAllList.push(data[i]);
            if (data[i].eduYn == "Y" && data[i].inYn !== "Y") {
              _eduList.push(Commons.DateFormating(data[i].edcDt, 2));
            }
            if (data[i].inYn === "Y") {
              _myEduList.push(Commons.DateFormating(data[i].edcDt, 2));
            }
          }
          setEduAllList(_eduAllList);
          setEduList(_eduList);
          setMyEduList(_myEduList);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 선택할 일자에 등록된 교육 데이터 조회
  const SelectLogic1 = async (_ymd) => {
    setLoading(true);

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Education.GetEduList,
        {
          ymd: _ymd,
        }
      ).then((result) => {
        let data = result.data;
        // console.log("선택할 날짜에 등록된 교육 데이터 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          setEduComboList([]);
          // throw new Error(data);
        } else if (data.length > 0) {
          setEduComboList([...data]);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 교육 상세 조회
  const SelectLogic2 = async (_ym = Commons.DateFormating(new Date(), 8)) => {
    setLoading(true);
    let _eduDetailList = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Education.GetDetail,
        {
          ym: _ym,
        }
      ).then((result) => {
        let data = result.data;
        // console.log("교육 상세 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          setEduDitailList([]);
          throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _eduDetailList.push(data[i]);
          }
          setEduDitailList(_eduDetailList);
          setDialogToggle(true);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 교육 신청
  const SaveLogic = async () => {
    setLoading(true);
    let _currentEduList = eduAllList.filter(
      (f) => f.edcDt == Commons.DateFormating(dateValue, 6)
    );

    try {
      if (!eduValue) {
        throw new Error("선택 날짜의 교육을 선택하세요.");
      }
      await Commons.Axios(
        "post",
        Global.base.useUrl + Global.urls.Education.Create,
        {
          edcId: eduValue,
          userId: "user",
          confmYn: "0",
        }
      ).then((result) => {
        let data = result.data;
        // console.log("교육 신청: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data === "Ok") {
          SelectLogic();
          Commons.Toast("success", "신청되었습니다.");
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 교육 취소
  const DeleteLogic = async (_params) => {
    setLoading(true);

    try {
      await Commons.Axios(
        "post",
        Global.base.useUrl + Global.urls.Education.Delete,
        _params
      ).then((result) => {
        let data = result.data;
        // console.log("교육 취소: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data === "Ok") {
          setDialogToggle1(false);
          SelectLogic();
          SelectLogic2();
          Commons.Toast("success", "취소되었습니다.");
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Calendar
        edus={eduList}
        myEdus={myEduList}
        dateState={dateValue}
        onChange={async (e) => {
          setDateValue(e);
          await SelectLogic(Commons.DateFormating(e, 8));
          await SelectLogic1(Commons.DateFormating(e, 6));
        }}
        onActiveStartDateChange={(e) => {
          SelectLogic(Commons.DateFormating(e, 8));
        }}
      />
      <Card>
        <Card.Body style={{ padding: "0px 8px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div
              style={{
                background: "blue",
                opacity: "0.5",
                width: "1.5rem",
                height: "0.4rem",
              }}
            />
            <p style={{ margin: 0 }}> &nbsp; &nbsp; 교육 신청이 가능한 날짜</p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div
              style={{
                background: "fuchsia",
                opacity: "0.5",
                width: "1.5rem",
                height: "0.4rem",
              }}
            />
            <p style={{ margin: 0 }}> &nbsp; &nbsp; 본인이 교육 신청한 날짜</p>
          </div>
        </Card.Body>
      </Card>
      <Card className="mt-3">
        <Card.Body className="input-card-body">
          <Dropdown
            variant="outline-primary"
            title="선택한 일자의 교육 리스트입니다."
            items={eduComboList}
            onChange={(e) => setEduValue(e)}
          />
        </Card.Body>
        <Card.Body className="input-card-body input-card-body___flex_space_between_center">
          <Button
            className="vacation-button___width"
            title="신청"
            onClick={SaveLogic}
          />
          <Button
            className="vacation-button___width"
            title="교육 조회"
            onClick={SelectLogic2}
          />
        </Card.Body>
      </Card>
      <Dialog
        header={false}
        fullscreen
        show={dialogToggle}
        onHide={() => setDialogToggle(false)}
        sumitButton={false}
      >
        <Calendar
          navClassName="custom-react-calendar-nav"
          todayButtonYn={false}
          dateState={dialogDateValue}
          // onChange={(e) => console.log(e)}
          onActiveStartDateChange={(e) =>
            SelectLogic2(Commons.DateFormating(e, 8))
          }
        />
        <Card>
          <Card.Body className="custom-table-grid-header">
            <Stack direction="horizontal">
              <div className="p-2 custom-table-grid-header-text custom-table-text-width-48">
                일자
              </div>
              <div className="p-2 custom-table-grid-header-text custom-table-text-width-208">
                교육종류
              </div>
              <div className="p-2 custom-table-grid-header-text custom-table-text-width-64">
                승인
              </div>
            </Stack>
          </Card.Body>
        </Card>
        <div className="custom-table-grid-datas">
          {eduDetailList.map((item, index) => {
            return (
              <Card key={index}>
                <Card.Body className="custom-table-grid-body">
                  <Stack direction="horizontal">
                    <div className="p-2 custom-table-grid-body-text custom-table-text-width-48">
                      {item.dd}
                    </div>
                    <div className="p-2 custom-table-grid-body-text custom-table-text-width-208">
                      {item.edcNm}
                    </div>
                    <div className="p-2 custom-table-grid-body-text custom-table-text-width-64">
                      {item.confirmYnNm == "신청" ? (
                        <Button
                          size="sm"
                          title="취소"
                          onClick={() => {
                            deleteDatas.current = { ...item };
                            setDialogToggle1(true);
                          }}
                        />
                      ) : (
                        item.processNm
                      )}
                    </div>
                  </Stack>
                </Card.Body>
              </Card>
            );
          })}
        </div>
      </Dialog>
      <Dialog
        title="교육 취소"
        show={dialogToggle1}
        onHide={() => setDialogToggle1(false)}
        sumitButtonName="확인"
        onSumit={() => DeleteLogic(deleteDatas.current)}
      >
        <p>{`${deleteDatas.current.edcId}교육을`}</p>
        <p>취소하시겠습니까?</p>
      </Dialog>
      <Loading show={loading} />
    </React.Fragment>
  );
}

export default Education;
